document.addEventListener('DOMContentLoaded', function() {
  // Function to display the popup
  function openPopupFunction() {
    alert('Popup Opened!'); // Replace this alert with your actual popup implementation
  }

  // Event delegation from the document to handle clicks on dynamic links
  document.addEventListener('click', function(e) {
    // Check if the clicked element is an anchor and its href is '#open-popup'
    if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#open-popup') {
      e.preventDefault();  // Stop the default action of the anchor
      openPopupFunction(); // Execute the popup function
    }
  });

  // Additional safety check for when the page loads directly with the hash
  if (window.location.hash === '#open-popup') {
    openPopupFunction();
  }

  // Listen for hash changes if the URL is updated manually
  window.addEventListener('hashchange', function() {
    if (window.location.hash === '#open-popup') {
      openPopupFunction();
    }
  }, false);
});